var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1057 0.00838456H1.89429C0.848571 0.00838456 0 0.838457 0 1.86138C0 2.30576 0.162857 2.73337 0.454286 3.06875L4.88571 8.12465C5.04857 8.3175 5.14286 8.56065 5.14286 8.8038V13.5327C5.14286 14.0442 5.40857 14.5137 5.85429 14.782C6.09429 14.9245 6.36857 15 6.64286 15C6.87429 15 7.09714 14.9497 7.31143 14.8407L9.02571 14.0022C9.54 13.7507 9.85714 13.2476 9.85714 12.6859V8.79542C9.85714 8.54388 9.95143 8.30073 10.1143 8.11627L14.5457 3.06037C14.8371 2.72499 15 2.29737 15 1.85299C15 0.830073 14.1514 0 13.1057 0V0.00838456ZM13.5686 2.24707L9.13714 7.30296C8.76857 7.72219 8.57143 8.25042 8.57143 8.8038V12.6942C8.57143 12.7781 8.52857 12.8452 8.45143 12.8787L6.73714 13.7172C6.64286 13.7675 6.56571 13.7339 6.53143 13.7088C6.49714 13.6836 6.42857 13.6333 6.42857 13.5327V8.8038C6.42857 8.25042 6.23143 7.72219 5.86286 7.30296L1.43143 2.24707C1.33714 2.13807 1.28571 2.00391 1.28571 1.86138C1.28571 1.53438 1.56 1.26607 1.89429 1.26607H13.1057C13.44 1.26607 13.7143 1.53438 13.7143 1.86138C13.7143 2.00391 13.6629 2.13807 13.5686 2.24707Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.3c9092cdb30bf770ef6f7e0f1cb61b78.svg";
export { ForwardRef as ReactComponent };